import "./_Gallery.scss";

interface IGallerySlides
{
	src: string;
	thumb?: string;
	type?: string;
}

interface GalleryImage
{
	Alt: string;
	LinkEl: HTMLLinkElement;
	ImageEl: HTMLImageElement;
	MainUrl: string;
	ThumbUrl: string;
	Type: string;
	ZoomUrl: string;
}

export class Gallery
{
	public BtnNext: HTMLButtonElement;
	public BtnPrev: HTMLButtonElement;
	public Links: NodeListOf<HTMLLinkElement>;
	public Images: Array<GalleryImage>;

	constructor()
	{
		const comingSoon = (document.querySelector("#hlSoon") !== null);

		if (!comingSoon)
		{
			this.ConfigureGallery();
		}
	}

	private get ActiveIndex(): number
	{
		const active = document.querySelector(".gal__img--cur");
		let index = 0;

		if (active !== null)
		{
			const indexString = active.getAttribute("data-index");

			if (indexString !== "" && typeof indexString !== "undefined")
			{
				index = parseInt(indexString);
			}
		}

		return index;
	};

	public ConfigureGallery = (): void =>
	{
		const gallery = document.querySelector(".gal");
		this.Links = document.querySelectorAll(".gal__img");

		this.Images = [];

		if (this.Links.length > 0)
		{
			this.Links.forEach((link, index) =>
			{
				const image: HTMLImageElement = link.querySelector("img");

				const galleryItem: GalleryImage = {
					Alt: image.alt,
					ImageEl: image,
					LinkEl: link,
					MainUrl: link.getAttribute("data-url"),
					ThumbUrl: image.src,
					Type: "image",
					ZoomUrl: link.getAttribute("href")
				};

				if (link.classList.contains("gal__img--vid"))
				{
					galleryItem.Type = "inline";
				}

				this.Images.push(galleryItem);
				link.addEventListener("click", this.SwapProductImage);
			});

			this.BtnNext = document.querySelector(".prdImg__next");
			this.BtnPrev = document.querySelector(".prdImg__prev");

			if (this.BtnNext !== null)
			{
				this.BtnNext.addEventListener("click", this.NextImage);
			}

			if (this.BtnPrev !== null)
			{
				this.BtnPrev.addEventListener("click", this.PreviousImage);
			}
		}
	};

	private NextImage = (e: Event): void =>
	{
		const newImage = this.ActiveIndex + 1;

		if (newImage >= this.Links.length)
		{
			e.preventDefault();
		}
		else
		{
			this.Links[newImage].dispatchEvent(new Event("click", { cancelable: true }));
			this.UpdateScrollPosition();
		}
	};

	private PreviousImage = (e: Event): void =>
	{
		const newImage = this.ActiveIndex - 1;

		if (newImage < 0)
		{
			e.preventDefault();
		}
		else
		{
			this.Links[newImage].dispatchEvent(new Event("click", { cancelable: true }));
			this.UpdateScrollPosition();
		}
	};

	public UpdateScrollPosition = (): void =>
	{
		const newImage: HTMLElement = document.querySelector(".gal__img--cur");
		const scrollPosition = newImage.offsetLeft;
		const scrollContainer = newImage.offsetParent;
		const containerPadding = parseFloat(getComputedStyle(scrollContainer).paddingLeft.replace("px", ""));

		scrollContainer.scrollTo({
			left: scrollPosition - containerPadding,
			behavior: "smooth"
		});
	};

	public SwapProductImage = (e: Event): void =>
	{
		e.preventDefault();

		const currentImageClass = "gal__img--cur";
		const clickTarget = e.currentTarget as HTMLLinkElement;
		const index = clickTarget.getAttribute("data-index");
		const galleryImage = this.Images[parseInt(index)];
		const mainLink = document.getElementById("hlZoom") as HTMLLinkElement;
		const mainImage = document.querySelector(".prdImg__img") as HTMLImageElement;

		if (mainLink !== null)
		{
			mainLink.href = galleryImage.ZoomUrl;
			mainLink.setAttribute("data-index", index);

			if (clickTarget.classList.contains("gal__img--vid"))
			{
				mainLink.classList.add("prdImg__lnk--vid");
				mainLink.setAttribute("data-video", clickTarget.getAttribute("data-video"));
			}
			else
			{
				mainLink.classList.remove("prdImg__lnk--vid");
				mainLink.setAttribute("data-video", "");
			}
		}

		if (mainImage !== null)
		{
			mainImage.alt = galleryImage.Alt;
			mainImage.src = galleryImage.MainUrl;
		}

		if (this.BtnNext !== null && this.BtnPrev !== null)
		{
			if (0 < parseInt(index) && parseInt(index) < this.Links.length - 1)
			{
				this.BtnNext.disabled = false;
				this.BtnPrev.disabled = false;
			}
			else if (parseInt(index) === 0)
			{
				this.BtnPrev.disabled = true;
			}
			else if (parseInt(index) === this.Links.length - 1)
			{
				this.BtnNext.disabled = true;
			}
		}

		document.querySelector(`.${currentImageClass}`).classList.remove(currentImageClass);
		clickTarget.classList.add(currentImageClass);
	};
}